// extracted by mini-css-extract-plugin
module.exports = {"successMessage":"styles_successMessage__vvlvi","successIcon":"styles_successIcon__z8eBt","successTitle":"styles_successTitle__qK5ml","successText":"styles_successText__u94p7"};